/*jshint esversion: 11 */
import moment from 'moment';
import { escapeCsvCell, downloadCsv } from './exportChildrenCsv';

export const CSV_HEADERS = [
  '#',
  'Message Sent',
  'Status Updated',
  'Child Name',
  'Purpose',
  'Message',
  'Status',
  'Mode',
  'Failure Reason'
];

export function isMessageLogStale(log, now = moment()) {
  return (
    log.status === 'sent' &&
    log.direction === 'outbound' &&
    log.sentAt &&
    now.diff(moment(log.sentAt), 'hours') >= 24
  );
}

export function formatDisplayPhone(phoneNumber) {
  if (!phoneNumber) return '—';
  return phoneNumber.replace(/^91/, '');
}

export function formatMessageLogChildName(log) {
  if (log.childName) return log.childName;
  const phone = formatDisplayPhone(log.phoneNumber);
  return phone === '—' ? '—' : phone;
}

export function formatMessageLogStatus(log, now = moment()) {
  if (isMessageLogStale(log, now)) return 'sent (no update)';
  return log.status || '';
}

export function formatMessageLogMode(log) {
  return log.direction === 'outbound' ? 'Message Sent' : 'Message Received';
}

export function formatMessageLogFailureReason(log) {
  if (!log.failureReason) return '—';
  const code = log.failureCode ? `[${log.failureCode}] ` : '';
  return `${code}${log.failureReason}`.trim();
}

export function enrichMessageLogForDisplay(log, page, limit, index, now = moment()) {
  return {
    ...log,
    srNo: (page - 1) * limit + index + 1,
    sentAtFormatted: log.sentAt ? moment(log.sentAt).format('DD MMM YYYY HH:mm') : '—',
    statusUpdatedAtFormatted: log.statusUpdatedAt
      ? moment(log.statusUpdatedAt).format('DD MMM YYYY HH:mm')
      : '—',
    displayPhone: formatDisplayPhone(log.phoneNumber),
    isStale: isMessageLogStale(log, now)
  };
}

export function formatMessageLogCsvRow(log, index, now = moment()) {
  return [
    index + 1,
    log.sentAt ? moment(log.sentAt).format('DD MMM YYYY HH:mm') : '—',
    log.statusUpdatedAt ? moment(log.statusUpdatedAt).format('DD MMM YYYY HH:mm') : '—',
    formatMessageLogChildName(log),
    log.purpose || '—',
    log.message || '',
    formatMessageLogStatus(log, now),
    formatMessageLogMode(log),
    formatMessageLogFailureReason(log)
  ];
}

export function buildWhatsAppMessageLogsCsv(logs, now = moment()) {
  const rows = logs || [];
  const csvRows = [CSV_HEADERS.map(escapeCsvCell).join(',')];
  rows.forEach((log, index) => {
    csvRows.push(formatMessageLogCsvRow(log, index, now).map(escapeCsvCell).join(','));
  });
  return csvRows.join('\n');
}

/** Strip characters unsafe for download filenames across common OSes. */
export function sanitizePurposeForFilename(purpose) {
  if (!purpose || !String(purpose).trim()) return '';
  return String(purpose)
    .trim()
    .replace(/[/\\?%*:|"<>]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 120);
}

/**
 * Export filename from the active Purpose filter, e.g. "Fee reminder" → fee-reminder-2026-05-30.csv
 */
export function buildWhatsAppMessageLogsExportFilename(purpose, dateStr = moment().format('YYYY-MM-DD')) {
  const slug = sanitizePurposeForFilename(purpose);
  const base = slug || 'whatsapp-message-history';
  return `${base}-${dateStr}.csv`;
}

export { downloadCsv };
